import { create } from "zustand";

type SiteDisabledState = {
  active: boolean;
  setActive: (active: boolean) => void;
};

export const useSiteDisabledStore = create<SiteDisabledState>((set) => ({
  active: false,
  setActive: (active) => set({ active }),
}));

export function activateSiteDisabled403(): void {
  useSiteDisabledStore.getState().setActive(true);
}
